// Canonical finish catalog shared by the landing page, designer routes and SEO.
export const SITE_URL = "https://2tsticker.ca";

export const FINISHES = [
  {
    slug: "white",
    key: "white_vinyl",
    name: "White Vinyl Stickers",
    ogImage: `${SITE_URL}/og/og-white.jpg`,
    title: "Custom White Vinyl Stickers in Canada | 2TSticker",
    description:
      "Order custom die-cut white vinyl stickers online. Vivid, waterproof, laminated prints with easy PNG upload and fast Canadian production.",
  },
  {
    slug: "transparent",
    key: "transparent_vinyl",
    name: "Transparent Stickers",
    ogImage: `${SITE_URL}/og/og-transparent.jpg`,
    title: "Custom Transparent Stickers in Canada | 2TSticker",
    description:
      "Custom clear vinyl stickers where only your artwork shows. Perfect for glass, windows and modern packaging — printed in Canada.",
  },
  {
    slug: "chrome",
    key: "chrome_vinyl",
    name: "Chrome Stickers",
    ogImage: `${SITE_URL}/og/og-chrome.jpg`,
    title: "Custom Chrome Stickers in Canada | 2TSticker",
    description:
      "Custom mirror-metallic chrome vinyl stickers with a bright reflective silver finish. Premium custom sticker printing, made in Canada.",
  },
  {
    slug: "holographic",
    key: "holographic_vinyl",
    name: "Holographic Stickers",
    ogImage: `${SITE_URL}/og/og-holographic.jpg`,
    title: "Custom Holographic Stickers in Canada | 2TSticker",
    description:
      "Custom holographic rainbow stickers with a colour-shifting shimmer. Eye-catching die-cut prints for packaging and branding, made in Canada.",
  },
];

export const finishBySlug = (slug) => FINISHES.find((f) => f.slug === slug);
export const finishByKey = (key) => FINISHES.find((f) => f.key === key);

export function productJsonLd(f) {
  return {
    "@context": "https://schema.org",
    "@type": "Product",
    name: f.name,
    description: f.description,
    image: f.ogImage,
    brand: { "@type": "Brand", name: "2TSticker" },
    url: `${SITE_URL}/stickers/${f.slug}`,
    offers: {
      "@type": "AggregateOffer",
      priceCurrency: "CAD",
      lowPrice: "0.57",
      highPrice: "4.14",
      offerCount: 10,
      availability: "https://schema.org/InStock",
      seller: { "@type": "Organization", name: "2TSticker" },
    },
  };
}
